"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_1 = require("../../../core/tooltip");
function calcProgressTimeTooltipCenterX(progressPercent, progressElementOffsetX, progressElementWidth) {
    return (progressElementOffsetX + (progressPercent * progressElementWidth) / 100);
}
function getProgressTimeTooltipPosition(progressPercent, progressElement, tooltipContainer) {
    return (0, tooltip_1.getTooltipPositionByReferenceElement)(progressElement, tooltipContainer, function (progressElementOffsetX, progressElementWidth) {
        return calcProgressTimeTooltipCenterX(progressPercent, progressElementOffsetX, progressElementWidth);
    });
}
exports.default = getProgressTimeTooltipPosition;
//# sourceMappingURL=getProgressTimeTooltipPosition.js.map